import PropTypes from 'prop-types';
import React from 'react';

const SuperPracticeBadge = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    fill="none"
    viewBox="0 0 100 100"
  >
    <g clipPath="url(#clip0_1520_373)">
      <path
        fill={color}
        fillRule="evenodd"
        d="M22.555 74.038h58.778V60.043H22.555v13.995zm60.178 2.799H21.156a1.4 1.4 0 01-1.4-1.4V58.644a1.4 1.4 0 011.4-1.4h61.577a1.4 1.4 0 011.4 1.4v16.793a1.4 1.4 0 01-1.4 1.4z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M27.74 57.243h48.411c.655-2.83.986-5.65.986-8.396v-23.47c-2.517.526-5.34 1.079-8.397 1.079-6.505 0-10.656-2.407-13.688-4.165-1.533-.889-2.501-1.433-3.106-1.433-.604 0-1.574.544-3.105 1.431-3.033 1.76-7.185 4.167-13.689 4.167-3.059 0-5.88-.553-8.397-1.08v23.47c0 2.745.332 5.565.986 8.397m49.507 2.8H26.642a1.4 1.4 0 01-1.355-1.05c-.883-3.414-1.33-6.827-1.33-10.146v-25.19a1.401 1.401 0 011.677-1.372l1.21.25c2.503.527 5.34 1.122 8.308 1.122 5.75 0 9.528-2.189 12.283-3.788 1.88-1.09 3.123-1.81 4.51-1.81 1.387 0 2.63.72 4.51 1.81 2.757 1.599 6.532 3.788 12.284 3.788 2.966 0 5.804-.595 8.307-1.121l1.213-.25a1.401 1.401 0 011.676 1.372v25.189c0 3.323-.448 6.737-1.332 10.147a1.4 1.4 0 01-1.355 1.048zM38.225 76.837c3.841 4.274 8.443 7.96 13.72 10.987 5.278-3.027 9.879-6.713 13.719-10.987H38.225zm13.72 13.994c-.235 0-.47-.058-.681-.176-6.806-3.791-12.577-8.616-17.153-14.344a1.401 1.401 0 01-.169-1.48 1.402 1.402 0 011.262-.793h33.481a1.4 1.4 0 011.094 2.273c-4.577 5.728-10.347 10.553-17.154 14.344-.21.118-.446.176-.68.176z"
        clipRule="evenodd"
      />
      <mask
        id="mask0_1520_373"
        style={{ maskType: 'luminance' }}
        width="50"
        height="23"
        x="27"
        y="74"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M27.055 74h49.778v22.429H27.054V74z" />
      </mask>
      <g mask="url(#mask0_1520_373)">
        <path
          fill={color}
          fillRule="evenodd"
          d="M31.325 76.837c5.225 6.67 12.147 12.252 20.619 16.62 8.472-4.368 15.394-9.95 20.62-16.62h-41.24zm20.619 19.592c-.216 0-.431-.05-.63-.15-10.099-5.093-18.146-11.834-23.916-20.038a1.398 1.398 0 011.145-2.204h46.802a1.398 1.398 0 011.144 2.204c-5.77 8.204-13.816 14.945-23.915 20.038-.199.1-.414.15-.631.15z"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="mask1_1520_373"
        style={{ maskType: 'luminance' }}
        width="68"
        height="49"
        x="18"
        y="12"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M18.278 12.46h67.334v47.651H18.278V12.46z" />
      </mask>
      <g mask="url(#mask1_1520_373)">
        <path
          fill={color}
          fillRule="evenodd"
          d="M22.25 57.243h59.391c.712-2.925 1.093-5.276 1.093-8.396v-30.22c-2.705.858-7.975 2.23-13.994 2.23-4.999 0-8.124-1.811-10.88-3.41-2.025-1.175-3.774-2.188-5.914-2.188-2.14 0-3.888 1.013-5.913 2.187-2.756 1.6-5.882 3.41-10.88 3.41-6.02 0-11.29-1.37-13.995-2.228v30.219c0 3.12.382 5.471 1.093 8.396m60.484 2.8H21.158c-.64 0-1.196-.435-1.356-1.053-.914-3.575-1.443-6.38-1.443-10.144V16.66a1.401 1.401 0 011.918-1.3c.068.026 6.868 2.7 14.876 2.7 4.246 0 6.905-1.543 9.478-3.034 2.275-1.319 4.423-2.565 7.316-2.565s5.042 1.246 7.317 2.565c2.572 1.49 5.231 3.033 9.477 3.033 8.034 0 14.806-2.671 14.875-2.7a1.402 1.402 0 011.919 1.3v32.188c0 3.764-.53 6.57-1.443 10.144a1.4 1.4 0 01-1.356 1.052"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="mask2_1520_373"
        style={{ maskType: 'luminance' }}
        width="26"
        height="21"
        x="9"
        y="62"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M9.96 62.778H34.5v19.667H9.96V62.778z" />
      </mask>
      <g mask="url(#mask2_1520_373)">
        <path
          fill={color}
          fillRule="evenodd"
          d="M13.975 79.635H29.99a54.843 54.843 0 01-2.166-2.8h-6.669a1.4 1.4 0 01-1.399-1.399V65.64h-5.781l4.146 6.22c.315.47.315 1.084 0 1.554l-4.146 6.22zm19.094 2.798H11.36a1.4 1.4 0 01-1.164-2.176l5.081-7.62-5.08-7.62a1.402 1.402 0 011.163-2.176h9.797c.774 0 1.4.627 1.4 1.4v9.796h5.988c.456 0 .883.222 1.144.594a53.944 53.944 0 004.41 5.456 1.398 1.398 0 01-1.029 2.346z"
          clipRule="evenodd"
        />
      </g>
      <mask
        id="mask3_1520_373"
        style={{ maskType: 'luminance' }}
        width="25"
        height="21"
        x="69"
        y="62"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M69.389 62.778h24.54v19.667h-24.54V62.778z" />
      </mask>
      <g mask="url(#mask3_1520_373)">
        <path
          fill={color}
          fillRule="evenodd"
          d="M73.898 79.635h16.016l-4.148-6.22a1.4 1.4 0 010-1.554l4.148-6.221h-5.782v9.796a1.4 1.4 0 01-1.4 1.4h-6.667a54.918 54.918 0 01-2.168 2.799m18.631 2.799H70.82a1.4 1.4 0 01-1.03-2.347 54 54 0 004.41-5.455 1.399 1.399 0 011.144-.595h5.988V64.24a1.4 1.4 0 011.4-1.399h9.796a1.4 1.4 0 011.164 2.176l-5.08 7.62 5.08 7.62a1.4 1.4 0 01-1.164 2.176"
          clipRule="evenodd"
        />
      </g>
      <path
        fill={color}
        d="M56.096 29.167c-.968 0-1.838.389-2.605.733-.586.262-1.138.508-1.559.508-.42 0-.975-.247-1.559-.508-.767-.344-1.636-.733-2.605-.733-3.236 0-7.212 3.485-7.212 6.32 0 1.336 2.971 16.432 7.212 16.432 1.62 0 1.858-1.753 2.11-3.607.337-2.47.724-4.515 2.054-4.515 1.33 0 1.717 2.045 2.054 4.515.253 1.855.492 3.607 2.11 3.607 4.24 0 7.212-15.096 7.212-16.432 0-2.835-3.976-6.32-7.212-6.32zm.507 19.591c-.04-.265-.079-.544-.113-.787-.342-2.507-.914-6.704-4.558-6.704-3.644 0-4.216 4.196-4.558 6.704-.033.244-.072.522-.113.787-1.729-2.537-4.177-11.188-4.177-13.271 0-1.253 2.576-3.792 4.684-3.792.428 0 .984.247 1.573.512.763.342 1.63.73 2.591.73.96 0 1.828-.39 2.591-.73.59-.265 1.146-.512 1.573-.512 2.108 0 4.684 2.54 4.684 3.792 0 2.083-2.448 10.734-4.177 13.271zM41.875 65.918a.47.47 0 00-.373-.315l-2.474-.362-1.108-2.24a.465.465 0 00-.42-.256.487.487 0 00-.42.256l-1.108 2.24-2.474.362a.455.455 0 00-.373.315.486.486 0 00.117.478l1.797 1.75-.42 2.462a.463.463 0 00.186.455c.14.105.339.117.49.035l2.217-1.167 2.216 1.167c.07.035.14.058.222.058a.503.503 0 00.28-.093c.14-.105.21-.28.187-.455l-.42-2.462 1.797-1.75a.534.534 0 00.081-.478zM56.32 65.918a.47.47 0 00-.374-.315l-2.473-.362-1.108-2.24a.465.465 0 00-.42-.256.487.487 0 00-.42.256l-1.109 2.24-2.473.362a.455.455 0 00-.373.315.487.487 0 00.116.478l1.797 1.75-.42 2.462a.463.463 0 00.186.455c.14.105.339.117.49.035l2.217-1.167 2.217 1.167c.07.035.14.058.221.058a.503.503 0 00.28-.093c.14-.105.21-.28.187-.455l-.42-2.462 1.797-1.75a.535.535 0 00.081-.478zM70.764 65.918a.47.47 0 00-.373-.315l-2.474-.362-1.108-2.24a.465.465 0 00-.42-.256.487.487 0 00-.42.256l-1.108 2.24-2.474.362a.455.455 0 00-.373.315.486.486 0 00.116.478l1.797 1.75-.42 2.462a.463.463 0 00.187.455c.14.105.338.117.49.035L66.4 69.93l2.217 1.167c.07.035.14.058.222.058a.503.503 0 00.28-.093c.14-.105.21-.28.186-.455l-.42-2.462 1.797-1.75a.534.534 0 00.082-.478zM97.167 25.334h.722c0-1.199.968-2.167 2.167-2.167v-.722a2.164 2.164 0 01-2.167-2.167h-.722A2.164 2.164 0 0195 22.445v.722c1.199 0 2.167.968 2.167 2.167z"
      />
      <path
        stroke={color}
        strokeWidth="2"
        d="M96.33 11.25a6.353 6.353 0 00-5.08 5.08 6.353 6.353 0 00-5.08-5.08 6.352 6.352 0 005.08-5.08 6.352 6.352 0 005.08 5.08zM11.33 53.75a6.352 6.352 0 00-5.08 5.08 6.352 6.352 0 00-5.08-5.08 6.352 6.352 0 005.08-5.08 6.352 6.352 0 005.08 5.08z"
      />
      <path
        fill={color}
        d="M54.445 34.167a.828.828 0 00-.834.833c0 .917-.75 1.667-1.666 1.667-.917 0-1.667-.75-1.667-1.667a.828.828 0 00-.833-.833.828.828 0 00-.834.833c0 1.833 1.5 3.333 3.334 3.333 1.833 0 3.333-1.5 3.333-3.333a.828.828 0 00-.833-.833z"
      />
    </g>
    <defs>
      <clipPath id="clip0_1520_373">
        <path fill="#fff" d="M0 0H100V100H0z" />
      </clipPath>
    </defs>
  </svg>
);
SuperPracticeBadge.propTypes = {
  color: PropTypes.string,
};

export default SuperPracticeBadge;
